import React from 'react';

import { EmptyResourceMessage } from '@/components/shared/EmptyResourceMessage';
import { VideoCollectionRow } from '@/components/VideoCollectionRow';
import { LinkFrom } from '@/config/constants';
import { GetDashboardQuery } from '@/graphql';
import { classNames } from '@/helpers/classNames';

import { LibraryTabProps } from '../../Library';
import libraryStyles from '../../Library.module.scss';

export const Done: React.FC<LibraryTabProps> = ({ videoCollections }) => {
	return !!videoCollections?.length ? (
		<>
			{videoCollections.map((vc) => (
				<VideoCollectionRow
					key={`done-video-collection-${vc.id}`}
					className={libraryStyles['video-collection']}
					videoCollection={vc}
					linkFrom={LinkFrom.library}
				/>
			))}
		</>
	) : (
		<div className={libraryStyles['empty-resource-wrapper']}>
			<EmptyResourceMessage
				title="Nothing to show"
				subtitle="You haven't completed any series yet."
			/>
		</div>
	);
};
